import React, { useState } from "react";
import { AppLayout } from "../../templates";
import useStyles from "./PlantManagementPage.css"
import { Button, Grid } from "@material-ui/core";
import { AppPopup } from "../../components";
import PlantAdd from "../../components/plant/PlantAdd";
import { CreateFactoryPayloadStructure } from "../../_models/app.models";
import { authorizationService } from "../../_services";
import { useDispatch, useSelector } from "react-redux";
import { factoryActions } from "../../_redux/actions";
import { alertActions } from "../../_redux/actions";
import PlantList from "../../components/plant/PlantList";
import PlantListFilters from "../../components/plant/PlantListFilters";

const PlantManagementPage = () => {
    const INITIAL_STATE = {
        addPlantPopup: false,
        addPlantReset: 0,
        popupFactory: {},
        plantList: []
    }
    const classes = useStyles();
    const dispatch = useDispatch();
    const [plantMgtPageState, setPlantMgtPageState] = useState(INITIAL_STATE);
    const factoryListState = useSelector((state: any) => state.factories.factoryList)
    const sbuListState = useSelector((state: any) => state.factories.sbuList);

    React.useEffect(() => {
        fetchFactoryList();
        fetchAllSbuList()
    }, [])

    const fetchFactoryList = () => {
        // Dispatch getFactoryList action to fetch factory list
        dispatch(factoryActions.getAllFactoryList(true,
            (data) => {
                setPlantMgtPageState({
                    ...plantMgtPageState,
                    plantList: data
                })
            },
            (error) => {
                // trigger alert onError
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }
        ))
    }

    const fetchAllSbuList = () => {
        dispatch(
            factoryActions.getAllSbuList(
                authorizationService.getAuthorizedUser().isAdmin,
                authorizationService.getAuthorizedUser().userEmail,
                () => { },
                (error) => {
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }
            )
        );
    }

    const toggleAddPlantPopup = (status: boolean, factory: any) => {
        setPlantMgtPageState({
            ...plantMgtPageState,
            addPlantPopup: status,
            popupFactory: factory
        });
    };

    const initPlantEdit = (popupStatus, plant) => {
        setPlantMgtPageState({
            ...plantMgtPageState,
            addPlantPopup: popupStatus,
            popupFactory: plant
        });
    }

    const onAddPlant = (data) => {
        const addFactoryPayload: CreateFactoryPayloadStructure = {
            sbuId: data.sbu.value,
            factoryId: data.factoryId.value,
            plantCode: data.plantCode.value,
            plantName: data.plantName.value,
            factoryCode: data.factoryCode.value,
            factoryName: data.factoryName.value,
            isActive: data.isActive.value,
            requestedBy: authorizationService.getAuthorizedUser().userEmail
        }
        dispatch(factoryActions.createFactory(addFactoryPayload,
            (data, responseMessage) => {
                // reset plant add from on plant create event (skip plant update event)
                if (!plantMgtPageState.popupFactory) {
                    const reset = plantMgtPageState.addPlantReset + 1;
                    setPlantMgtPageState({
                        ...plantMgtPageState,
                        addPlantReset: reset
                    })
                }
                dispatch(alertActions.triggerAlert(true, responseMessage, 'success'))
                // Dispatch getFactoryList action to fetch factory list
                fetchFactoryList();
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }
        ))
    }

    const onFilterChange = (filters) => {
        const data = factoryListState.data;
        let filterBy = {};
        if (!!filters.sbu) { filterBy[`sbuId`] = [filters.sbu] }
        if (!!filters.plant) { filterBy[`plantId`] = [filters.plant] }

        const result = data.filter(function (o) {
            return Object.keys(filterBy).every(function (k) {
                return filterBy[k].some(function (f) {
                    return o[k] === f;
                });
            });
        });
        setPlantMgtPageState({
            ...plantMgtPageState,
            plantList: result
        })
    }

    const onFilterClear = () => {
        fetchFactoryList();
    }

    return (
        <AppLayout>
            <AppPopup
                open={plantMgtPageState.addPlantPopup}
                onClose={(status) => toggleAddPlantPopup(status, null)}
                fullWidth={true}
                maxWidth='sm'
                title={"Add / Update factory"}>
                <PlantAdd
                    sbus={sbuListState.data}
                    reset={plantMgtPageState.addPlantReset}
                    plant={plantMgtPageState.popupFactory}
                    addPlant={(data) => onAddPlant(data)}
                    onClose={(status) => toggleAddPlantPopup(status, null)}
                />
            </AppPopup>

            <Grid container className={'appPageHeader'}>
                <Grid container item xs={12} sm={12} md={7} lg={7} justify="flex-start" alignContent="center">
                    <span className={'pageTitle'}>Factory <b>Management</b></span>
                </Grid>
                <Grid container item xs={12} sm={12} md={5} lg={5} justify="flex-end" alignContent="center">
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => toggleAddPlantPopup(true, null)}
                    >Add Factory</Button>
                </Grid>
            </Grid>
            <div className="appPageContent">
                <PlantListFilters
                    sbus={sbuListState.data}
                    onFilterClear={() => onFilterClear()}
                    onFilterChange={(filters) => onFilterChange(filters)} />
                <PlantList
                    data={plantMgtPageState.plantList}
                    isLoading={factoryListState.isLoading}
                    onPlantEditTrigger={(popupStatus, plant) => initPlantEdit(popupStatus, plant)}
                />
            </div>
        </AppLayout>
    )
}

export default PlantManagementPage;
